type Translate = (key: string, params?: Record<string, unknown>) => string

/*
 * 그룹 삭제 가능 여부 가드 — 순수 로직(리졸버에서 분리해 단위 테스트 가능).
 * - 도메인 내에 그룹이 없으면 not-found 로 거절.
 * - 소속 보드가 하나라도 있으면 삭제를 차단(고아 보드 방지). 먼저 보드를 옮기거나 제거해야 한다.
 */
export function assertGroupDeletable(group: unknown, boardCount: number, t: Translate): void {
  if (!group) {
    throw new Error(t('error.group not found'))
  }
  if (boardCount > 0) {
    throw new Error(t('error.group has boards', { count: boardCount }))
  }
}
